// src/components/Bookpair/Bookpair.tsx

import React, {
    useState,
    useEffect,
    FC,
    ChangeEvent
} from "react";
import { indexWrapCss, widthCss } from "./css/Home.style";
import Footer from "../layouts/footer/Footer";
import Header from "../layouts/header/Header";

import CalendarViewer from "./ClaendarViewer";
import { css } from "@emotion/react";
import { useIsMobile } from "../../hooks/useIsMobile";
import usePageTitle from "../../hooks/usePageTitle";

interface CalendarEvent {
    summary?: string;
    location?: string;
    description?: string;
    start?: {
        dateTime?: string;
        date?: string;
    };
    end?: {
        dateTime?: string;
        date?: string;
    };
}

const Bookpair: FC = () => {
    usePageTitle("북밋 북페어");

    const isMobile = useIsMobile();

    const mobilePaddingOverrideCss = css`
        @media (max-width: 768px) {
            padding-top: 32px !important;
            padding-bottom: 32px !important;
            min-width: unset !important;
            width: 100%;
        }
    `;

    const ENV_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
    const ENV_CALENDAR_ID = process.env.REACT_APP_GOOGLE_CALENDAR_ID;

    const [events, setEvents] = useState<CalendarEvent[]>([]);
    const [statusMessage, setStatusMessage] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (!ENV_API_KEY || !ENV_CALENDAR_ID) {
            setStatusMessage("API 설정이 누락되었습니다.");
            return;
        }

        const now = new Date();
        const pastOneYear = new Date();
        pastOneYear.setFullYear(now.getFullYear() - 1);
        const futureOneYear = new Date();
        futureOneYear.setFullYear(now.getFullYear() + 1);

        const params = new URLSearchParams({
            key: ENV_API_KEY,
            timeMin: pastOneYear.toISOString(),
            timeMax: futureOneYear.toISOString(),
            showDeleted: "false",
            singleEvents: "true",
            maxResults: "10",
            orderBy: "startTime",
        });

        setIsLoading(true);
        fetch(
            `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(ENV_CALENDAR_ID)}/events?${params}`
        )
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    console.error("Calendar API Error:", data.error);
                    setStatusMessage("캘린더 데이터를 불러오지 못했습니다.");
                } else {
                    setEvents(data.items || []);
                    setStatusMessage("");
                }
            })
            .catch((err) => {
                console.error("Fetch Error:", err);
                setStatusMessage("캘린더 데이터를 불러오지 못했습니다.");
            })
            .finally(() => setIsLoading(false));
    }, [ENV_API_KEY, ENV_CALENDAR_ID]);


    const onSearchHandler = (e: ChangeEvent<HTMLInputElement>) =>
        setSearch(e.target.value);


    return (
        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="bookpair"
            />
            {/* 히어로 배너 섹션 */}
            <div style={{ background: 'linear-gradient(180deg, #e8f8f0 0%, #edf9f3 40%, #fafafa 100%)' }}
                 className="w-full pt-14 pb-16 md:pt-10 md:pb-12 px-4">
                <div className="max-w-[720px] mx-auto flex flex-col items-center text-center gap-2">

                    {/* 타이틀 */}
                    <h1 className={`font-bold text-[#222] leading-tight ${isMobile ? 'text-[26px]' : 'text-[38px]'}`}>
                        📅 북페어 캘린더
                    </h1>

                    {/* 서브텍스트 */}
                    <p className={`text-[#888] leading-relaxed ${isMobile ? 'text-[13px]' : 'text-[16px]'}`}>
                        전국에서 열리는 북페어 정보를 확인하고 <br className="hidden md:block"/>
                        원하는 곳에 방문해 보세요!
                    </p>

                    {/* 통계 or 뱃지 */}
                    {/*<div className="flex items-center gap-3 mt-2 flex-wrap justify-center">
                        <span className="flex items-center gap-1.5 bg-white border border-[#f0f0f0] text-[#555] text-[13px] font-medium px-3 py-1.5 rounded-full shadow-sm">
                            📅 일정 업데이트 중
                        </span>
                        <span className="flex items-center gap-1.5 bg-white border border-[#f0f0f0] text-[#555] text-[13px] font-medium px-3 py-1.5 rounded-full shadow-sm">
                            📍 전국 북페어 모음
                        </span>
                    </div>*/}
                </div>
            </div>

            {/* 이벤트 뷰어 섹션 */}
            <div css={[widthCss, isMobile && mobilePaddingOverrideCss]}  >
                <CalendarViewer
                    events={events}
                    statusMessage={statusMessage}
                    isLoading={isLoading}
                />
            </div>

            <Footer />
        </div>
    );
};

export default Bookpair;
